import { Button, Dropdown, Menu } from "antd";
import Cookies from "js-cookie";
import React, { Fragment, useEffect, useState } from "react";
import { AlignLeft, Maximize2, MoreHorizontal } from "react-feather";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import logo from "../../../assets/images/dashboard/multikart-logo.png";
import cnFlag from "../../../assets/images/flags/cn.png";
import ukFlag from "../../../assets/images/flags/uk.png";
import { updateToken } from "../../../axios";
import { me, refresh } from "../../../store/adminSlice";
import UserMenu from "./user-menu";

const Header = () => {
  const [sidebar, setSidebar] = useState(true);
  const [rightSidebar, setRightSidebar] = useState(true);
  const [navMenus, setNavMenus] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.admin);
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  updateToken(user.token);

  useEffect(() => {
    if (user.type && !user.admin.hasOwnProperty("role")) {
      dispatch(me(user.token));
    } else if (
      !user.type &&
      !user.token &&
      !user.refresh &&
      !Cookies.get("logss")
    ) {
      navigate("/");
    } else if (!user.type || !user.admin.hasOwnProperty("role")) {
      dispatch(refresh()).then((data) => {
        dispatch(me(data?.payload?.access));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const toggle = () => {
    setNavMenus(!navMenus);
  };

  const goFull = () => {
    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT,
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  };

  const openCloseSidebar = () => {
    if (sidebar) {
      setSidebar(false);
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
      document.querySelector(".footer").classList.add("open");
    } else {
      setSidebar(true);
      document.querySelector(".page-main-header").classList.remove("open");
      document.querySelector(".page-sidebar").classList.remove("open");
      document.querySelector(".footer").classList.remove("open");
    }
  };

  // Dropdown menu items
  const menu = (
    <Menu>
      <Menu.Item key="en" onClick={() => changeLanguage("en")}>
        <img
          src={ukFlag}
          alt="English"
          style={{ width: "20px", marginRight: "8px" }}
        />
        English
      </Menu.Item>
      <Menu.Item key="zh" onClick={() => changeLanguage("zh")}>
        <img
          src={cnFlag}
          alt="Chinese (Simplified)"
          style={{ width: "20px", marginRight: "8px" }}
        />
        中文 (简体)
      </Menu.Item>
    </Menu>
  );

  return (
    <Fragment>
      <div className="page-main-header">
        <div className="main-header-right row">
          <div className="main-header-left d-lg-none col-auto">
            <div className="logo-wrapper">
              <a href="index.html">
                <img className="blur-up lazyloaded" src={logo} alt="" />
              </a>
            </div>
          </div>
          <div className="mobile-sidebar col-auto p-0">
            <div className="media-body text-end switch-sm">
              <label className="switch">
                <a href="#javaScript" onClick={openCloseSidebar}>
                  <AlignLeft />
                </a>
              </label>
            </div>
          </div>
          <div className="nav-right col">
            <ul className={"nav-menus " + (navMenus ? "open" : "")}>
              <li>
                <a onClick={goFull} className="text-dark" href="#javaScript">
                  <Maximize2 />
                </a>
              </li>
              <li>
                <Dropdown overlay={menu} trigger={["click"]}>
                  <Button>
                    <img
                      src={i18n.language?.startsWith("zh") ? cnFlag : ukFlag}
                      alt={t("language")}
                      style={{ width: "20px", marginRight: "8px" }}
                    />
                    {t("language")}
                  </Button>
                </Dropdown>
              </li>
              <UserMenu />
            </ul>
            <div
              className="d-lg-none mobile-toggle pull-right"
              onClick={() => toggle()}
            >
              <MoreHorizontal />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Header;
